export default __webpack_public_path__ + "static/media/logo-loader.3f5c8be6.png";